import { ArrowRight, CheckCircle2, Star, Phone, Building2, Shield, Clock, ChevronDown, Users, Truck, Package, Briefcase, Monitor, FileText, Calendar } from 'lucide-react';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Contact from '../components/Contact';

export default function Firmenumzuege() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const scrollToContact = () => {
    const element = document.getElementById('kontakt');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  const benefits = [
    'Firmenumzug Schweiz Deutschland - Spezialisiert auf internationale Firmenumzüge',
    'Büroumzug Schweiz Deutschland ausserhalb Geschäftszeiten',
    'Minimale Ausfallzeiten beim Umzug Schweiz Deutschland',
    'Professioneller IT-Transport für Firmenumzug Schweiz Deutschland',
    'Vollversicherung für Firmenumzug Schweiz Deutschland',
    'Erfahrene Umzugsfirma für Firmenumzüge Schweiz Deutschland',
  ];

  const services = [
    {
      icon: Building2,
      title: 'Büroumzüge',
      description: 'Kompletter Umzug Ihres Büros von der Schweiz nach Deutschland. Wir koordinieren alle Schritte, vom Abbau bis zur Neueinrichtung.',
      features: [
        'Schreibtische und Büromöbel',
        'Aktenschränke und Regale',
        'Besprechungstische',
        'Empfangsmöbel',
      ],
    },
    {
      icon: Monitor,
      title: 'IT-Umzüge',
      description: 'Sicherer Transport Ihrer IT-Infrastruktur. Unsere Spezialisten kennen sich mit empfindlicher Technik aus.',
      features: [
        'Server und Netzwerk-Equipment',
        'Computer und Monitore',
        'Drucker und Scanner',
        'Verkabelung und Installation',
      ],
    },
    {
      icon: Package,
      title: 'Lager & Logistik',
      description: 'Umzug von Lagerbeständen, Archiven und Inventar. Auch grosse Mengen bewältigen wir professionell.',
      features: [
        'Lagerbestände',
        'Archivmaterial',
        'Produktionsanlagen (klein)',
        'Zwischenlagerung möglich',
      ],
    },
    {
      icon: Briefcase,
      title: 'Praxisumzüge',
      description: 'Spezialisiert auf Arzt-, Zahnarzt- und Anwaltspraxen. Wir wissen, wie sensibel diese Umzüge sind.',
      features: [
        'Medizinische Geräte',
        'Behandlungsstühle',
        'Empfangsbereich',
        'Patientenakten (DSGVO-konform)',
      ],
    },
  ];

  const companySizes = [
    {
      size: 'Kleine Büros',
      employees: '1-5 Mitarbeiter',
      description: 'Startups, Einzelunternehmen, kleine Teams',
      price: 'ab CHF 1\'200.–',
      includes: [
        'Bis 30m² Bürofläche',
        '5-10 Arbeitsplätze',
        'Standard-Büromöbel',
        'IT-Equipment',
        'Umzug an 1 Tag',
      ],
    },
    {
      size: 'Mittlere Büros',
      employees: '6-20 Mitarbeiter',
      description: 'Etablierte Firmen, Agenturen, Kanzleien',
      price: 'ab CHF 3\'500.–',
      popular: true,
      includes: [
        'Bis 100m² Bürofläche',
        '10-25 Arbeitsplätze',
        'Komplette Büroausstattung',
        'IT-Infrastruktur',
        'Umzug in 1-2 Tagen',
        'Wochenendumzug möglich',
      ],
    },
    {
      size: 'Grosse Büros',
      employees: 'ab 20 Mitarbeiter',
      description: 'Unternehmen, Konzerne, Niederlassungen',
      price: 'Individuelle Offerte',
      includes: [
        'Ab 100m² Bürofläche',
        'Ab 25 Arbeitsplätze',
        'Komplexe IT-Systeme',
        'Serverräume',
        'Mehrere Umzugstage',
        'Projektmanager vor Ort',
        'Stufenweise Umzugsplanung',
      ],
    },
  ];

  const whyChooseUs = [
    {
      icon: Clock,
      title: 'Minimale Ausfallzeiten',
      description: 'Wir planen den Umzug so, dass Ihr Geschäftsbetrieb minimal beeinträchtigt wird. Umzug am Wochenende oder nachts ist möglich.',
    },
    {
      icon: Shield,
      title: 'Vollständig versichert',
      description: 'Ihre wertvolle Firmenausstattung ist während des Transports vollständig versichert. Auch für IT-Equipment und sensible Geräte.',
    },
    {
      icon: Users,
      title: 'Erfahrenes Team',
      description: 'Unsere Mitarbeiter sind speziell für Firmenumzüge geschult. Diskretion und Professionalität sind selbstverständlich.',
    },
    {
      icon: FileText,
      title: 'Komplettservice',
      description: 'Von der Planung bis zur Einrichtung – wir übernehmen alles. Inkl. Zollabwicklung, Verpackung und Möbelmontage.',
    },
  ];

  const processSteps = [
    {
      step: '1',
      title: 'Bedarfsanalyse',
      description: 'Besichtigung vor Ort, Erfassung aller Gegenstände und Erstellung eines detaillierten Umzugsplans.',
    },
    {
      step: '2',
      title: 'Planung & Koordination',
      description: 'Zeitplan erstellen, Ressourcen zuweisen, IT-Umzug koordinieren. Bei grossen Umzügen: Projektmanager.',
    },
    {
      step: '3',
      title: 'Vorbereitung',
      description: 'Bereitstellung von Verpackungsmaterial, Beschriftung, Inventarlisten. Mitarbeiter werden informiert.',
    },
    {
      step: '4',
      title: 'Durchführung',
      description: 'Professioneller Umzug nach Plan. Bei Bedarf ausserhalb der Geschäftszeiten (Wochenende/Nacht).',
    },
    {
      step: '5',
      title: 'Einrichtung',
      description: 'Aufbau und Einrichtung am neuen Standort. IT-Installation, Möbelmontage, Übergabe.',
    },
  ];

  const specialServices = [
    {
      title: 'IT-Umzug mit Spezialisten',
      description: 'Unsere IT-Experten demontieren, transportieren und installieren Ihre komplette IT-Infrastruktur. Server, Netzwerke, Verkabelung – alles aus einer Hand.',
      icon: Monitor,
    },
    {
      title: 'Wochenend- & Nachtumzüge',
      description: 'Damit Ihr Geschäftsbetrieb nicht stillsteht, ziehen wir am Wochenende oder nachts um. Montag früh können Sie im neuen Büro arbeiten.',
      icon: Clock,
    },
    {
      title: 'Lagerung & Archivierung',
      description: 'Nicht alles kommt sofort ins neue Büro? Wir lagern Akten, Inventar oder Möbel zwischenzeitlich in unseren Lagerhallen ein.',
      icon: Package,
    },
    {
      title: 'Entsorgung & Recycling',
      description: 'Alte Möbel, IT-Geräte oder Akten? Wir entsorgen fachgerecht und umweltfreundlich – inklusive DSGVO-konformer Aktenvernichtung.',
      icon: FileText,
    },
  ];

  const advantages = [
    {
      title: 'Internationale Erfahrung',
      description: 'Wir kennen uns mit grenzüberschreitenden Umzügen aus. Zollabwicklung, Dokumentation und Vorschriften – alles kein Problem.',
    },
    {
      title: 'Keine versteckten Kosten',
      description: 'Sie erhalten eine transparente Festpreis-Offerte. Keine Überraschungen, keine Zusatzkosten.',
    },
    {
      title: 'Projektmanagement',
      description: 'Bei grossen Umzügen erhalten Sie einen dedizierten Projektmanager als Ansprechpartner.',
    },
    {
      title: 'Flexible Termine',
      description: 'Wir richten uns nach Ihrem Zeitplan. Auch kurzfristige Umzüge oder Verschiebungen sind möglich.',
    },
    {
      title: 'Diskretion garantiert',
      description: 'Ihre Geschäftsgeheimnisse sind bei uns sicher. Alle Mitarbeiter sind zur Verschwiegenheit verpflichtet.',
    },
    {
      title: 'Einrichtungsservice',
      description: 'Wir richten Ihr neues Büro komplett ein. Vom Schreibtisch bis zur IT – alles einsatzbereit.',
    },
  ];

  const checklist = [
    {
      phase: 'Vor dem Umzug',
      items: [
        'Bestandsaufnahme erstellen',
        'Mitarbeiter informieren',
        'Umzugstermin festlegen',
        'Alte Verträge kündigen (Internet, etc.)',
        'Neue Adresse kommunizieren',
        'Parkplätze reservieren',
      ],
    },
    {
      phase: 'Während des Umzugs',
      items: [
        'Beschriftung aller Kartons',
        'Inventarliste führen',
        'Wertvolle Gegenstände persönlich transportieren',
        'Letzte Kontrolle alter Räume',
        'Schlüsselübergabe koordinieren',
      ],
    },
    {
      phase: 'Nach dem Umzug',
      items: [
        'Möbel aufbauen lassen',
        'IT-Systeme testen',
        'Adressänderung bei Behörden',
        'Neue Visitenkarten bestellen',
        'Mitarbeiter einweisen',
        'Endreinigung alte Räume',
      ],
    },
  ];

  const testimonials = [
    {
      name: 'IT-Solutions GmbH',
      location: 'Zürich → München',
      employees: '15 Mitarbeiter',
      text: 'Professionell und pünktlich! Der Umzug wurde übers Wochenende durchgeführt. Montag morgen konnten wir direkt weiterarbeiten.',
      rating: 5,
    },
    {
      name: 'Rechtsanwälte Meyer & Partner',
      location: 'Basel → Frankfurt',
      employees: '8 Mitarbeiter',
      text: 'Sehr sorgfältiger Umgang mit unseren Mandantenakten. Alles wurde diskret und DSGVO-konform behandelt. Top!',
      rating: 5,
    },
    {
      name: 'TechStartup AG',
      location: 'Bern → Berlin',
      employees: '12 Mitarbeiter',
      text: 'Als Startup hatten wir ein knappes Budget. Das Preis-Leistungs-Verhältnis war fair und transparent. Empfehlenswert!',
      rating: 5,
    },
  ];

  const faqs = [
    {
      question: 'Was kostet ein Firmenumzug von der Schweiz nach Deutschland?',
      answer: 'Die Kosten hängen von mehreren Faktoren ab:<br><br>• <strong>Bürogrösse:</strong> Anzahl Arbeitsplätze, m² Fläche<br>• <strong>Inventar:</strong> Menge und Art der Möbel/Geräte<br>• <strong>IT-Infrastruktur:</strong> Server, Netzwerke, Computer<br>• <strong>Entfernung:</strong> Von wo nach wo in Deutschland<br>• <strong>Zusatzleistungen:</strong> IT-Umzug, Wochenendumzug, Lagerung<br><br><strong>Richtwerte:</strong><br>• Klein (1-5 MA): ab CHF 1\'200.–<br>• Mittel (6-20 MA): ab CHF 3\'500.–<br>• Gross (20+ MA): Individuelle Offerte<br><br>Kontaktieren Sie uns für eine kostenlose Besichtigung und Offerte.'
    },
    {
      question: 'Wie lange dauert ein Firmenumzug?',
      answer: 'Die Dauer hängt von der Grösse Ihres Unternehmens ab:<br><br>• <strong>Kleine Büros (1-5 MA):</strong> 1 Tag<br>• <strong>Mittlere Büros (6-20 MA):</strong> 1-2 Tage<br>• <strong>Grosse Büros (20+ MA):</strong> 2-5 Tage oder mehr<br><br>Bei Wochenendumzügen ziehen wir oft Freitag Abend aus und richten Samstag/Sonntag ein – damit Sie Montag arbeiten können.<br><br>Für grosse Unternehmen planen wir <strong>stufenweise Umzüge</strong>, damit nicht alle Abteilungen gleichzeitig ausfallen.'
    },
    {
      question: 'Können Sie auch ausserhalb der Geschäftszeiten umziehen?',
      answer: 'Ja, das ist sogar unsere <strong>Spezialität bei Firmenumzügen</strong>! Wir bieten:<br><br><strong>Wochenendumzüge:</strong><br>• Freitag Abend: Abbau und Verpackung<br>• Samstag: Transport<br>• Sonntag: Aufbau und Einrichtung<br>• Montag: Geschäftsbetrieb läuft normal<br><br><strong>Nachtumzüge:</strong><br>• Ab 18:00 Uhr bis 06:00 Uhr morgens<br>• Ideal für Unternehmen die nicht schliessen können<br><br>Für Wochenend- und Nachtumzüge berechnen wir einen Aufpreis von 20-30%.'
    },
    {
      question: 'Wie wird der IT-Umzug durchgeführt?',
      answer: 'Unser <strong>IT-Umzug erfolgt durch Spezialisten</strong>:<br><br><strong>Vorbereitung:</strong><br>• Bestandsaufnahme aller IT-Geräte<br>• Dokumentation der Verkabelung (Fotos)<br>• Backup-Empfehlung<br>• Planung der neuen IT-Infrastruktur<br><br><strong>Demontage:</strong><br>• Fachgerechtes Abklemmen aller Systeme<br>• Beschriftung aller Kabel<br>• Sichere Verpackung (antistatisch)<br><br><strong>Transport:</strong><br>• In speziellen IT-Boxen<br>• Schockgeschützt<br><br><strong>Installation:</strong><br>• Neuaufbau nach Dokumentation<br>• Verkabelung<br>• Funktionstest<br><br>Optional: IT-Techniker vor Ort für komplexe Systeme.'
    },
    {
      question: 'Ist meine Firmenausstattung während des Umzugs versichert?',
      answer: 'Ja, Ihre komplette Firmenausstattung ist <strong>vollständig versichert</strong>:<br><br><strong>Standard-Versicherung (inklusive):</strong><br>• Büromöbel und Ausstattung<br>• Computer und IT-Equipment<br>• Dokumente und Akten<br>• Versicherungssumme: bis CHF 200\'000<br><br><strong>Erweiterte Versicherung (optional):</strong><br>• Für besonders wertvolle Ausstattung<br>• Server und spezielle IT-Systeme<br>• Medizinische Geräte<br>• Höhere Deckungssummen<br><br>Wir erstellen vor dem Umzug eine Inventarliste zur Dokumentation.'
    },
    {
      question: 'Müssen unsere Mitarbeiter beim Umzug helfen?',
      answer: 'Nein, <strong>Ihre Mitarbeiter müssen nicht mithelfen</strong>. Wir übernehmen den kompletten Umzug:<br><br><strong>Wir erledigen:</strong><br>• Verpackung aller Gegenstände<br>• Abbau der Möbel<br>• Transport<br>• Aufbau am neuen Standort<br>• Einrichtung nach Plan<br><br><strong>Ihre Mitarbeiter sollten:</strong><br>• Persönliche Gegenstände einpacken<br>• Wichtige Dokumente separat sichern<br>• Computer herunterfahren<br>• Schreibtische aufräumen<br><br>Auf Wunsch übernehmen wir auch das Einpacken persönlicher Gegenstände.'
    },
    {
      question: 'Wie läuft die Zollabwicklung bei einem Umzug nach Deutschland ab?',
      answer: 'Wir kümmern uns um die <strong>komplette Zollabwicklung</strong>:<br><br><strong>Benötigte Dokumente (für uns):</strong><br>• Firmendaten (Handelsregisterauszug)<br>• Inventarliste (erstellen wir)<br>• Nachweis der Geschäftsverlagerung<br><br><strong>Wir erledigen:</strong><br>• Ausfuhrzollanmeldung Schweiz<br>• Einfuhrzollanmeldung Deutschland<br>• Kommunikation mit Zollbehörden<br>• Alle Formalitäten<br><br><strong>Zollkosten:</strong><br>• Bei Geschäftsverlagerung: meist zollfrei<br>• MwSt wird fällig (Deutschland: 19%)<br>• Zollabwicklungsgebühr: CHF 200-400<br><br>Sie müssen sich um nichts kümmern – wir regeln alles!'
    },
    {
      question: 'Können Sie auch alte Büromöbel entsorgen?',
      answer: 'Ja, wir bieten einen <strong>kompletten Entsorgungsservice</strong>:<br><br><strong>Was wir entsorgen:</strong><br>• Alte Büromöbel<br>• Ausgediente IT-Geräte<br>• Akten und Dokumente (DSGVO-konform)<br>• Elektroschrott<br>• Verpackungsmaterial<br><br><strong>Wie wir entsorgen:</strong><br>• Umweltfreundlich und fachgerecht<br>• Recycling wo möglich<br>• Datenvernichtung nach DIN 66399<br>• Entsorgungsnachweise<br><br><strong>Kosten:</strong><br>• Abhängig von Menge und Art<br>• Separate Offerte<br>• Oft günstiger als selbst entsorgen'
    },
    {
      question: 'Was passiert mit sensiblen Dokumenten und Daten?',
      answer: 'Der Schutz Ihrer sensiblen Daten hat <strong>höchste Priorität</strong>:<br><br><strong>Physische Dokumente:</strong><br>• Transport in verschlossenen Boxen<br>• Separate Kennzeichnung<br>• Nur autorisiertes Personal<br>• Verschwiegenheitsverpflichtung<br>• Optional: Versiegelung<br><br><strong>IT-Geräte:</strong><br>• Sichere Verpackung<br>• Kein unbefugter Zugriff<br>• Empfehlung: Backup vor Umzug<br><br><strong>Aktenvernichtung (optional):</strong><br>• DSGVO-konforme Vernichtung<br>• Nach DIN 66399 Sicherheitsstufe 3-4<br>• Vernichtungszertifikat<br><br>Alle Mitarbeiter sind zur <strong>Diskretion verpflichtet</strong>.'
    },
    {
      question: 'Können Sie auch kurzfristig umziehen?',
      answer: 'Ja, wir sind auch bei <strong>kurzfristigen Anfragen</strong> für Sie da:<br><br><strong>Reguläre Planung:</strong><br>• Empfohlen: 4-6 Wochen Vorlauf<br>• Ermöglicht optimale Planung<br>• Beste Terminauswahl<br><br><strong>Express-Umzug:</strong><br>• Möglich innerhalb 1-2 Wochen<br>• Aufpreis: 20-30%<br>• Nach Verfügbarkeit<br><br><strong>Not-Umzug:</strong><br>• In Ausnahmefällen innerhalb weniger Tage<br>• Höherer Aufpreis<br>• Begrenzte Kapazität<br><br>Kontaktieren Sie uns – wir versuchen immer eine Lösung zu finden!'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <section className="relative bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white py-20 min-h-[700px] overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
            backgroundSize: '40px 40px'
          }} />
        </div>

        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <div className="inline-block bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full text-sm font-semibold mb-6 border border-white/20">
              Professionelle Firmenumzüge
            </div>

            <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
              Firmenumzüge Schweiz → Deutschland
            </h1>

            <p className="text-xl md:text-2xl text-slate-200 mb-8 leading-relaxed">
              Ihr Büro umziehen – mit minimalen Ausfallzeiten und maximalem Service
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
              <button
                onClick={scrollToContact}
                className="bg-white text-slate-900 px-8 py-4 rounded-lg font-semibold hover:bg-slate-100 transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 flex items-center justify-center space-x-2"
              >
                <span>Gratis Offerte erhalten</span>
                <ArrowRight className="w-5 h-5" />
              </button>
              <a
                href="tel:0800700100"
                className="bg-slate-700/50 backdrop-blur-sm text-white px-8 py-4 rounded-lg font-semibold hover:bg-slate-700 transition-all duration-300 border border-white/20 flex items-center justify-center space-x-2"
              >
                <Phone className="w-5 h-5" />
                <span>0800 700 100</span>
              </a>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl mx-auto">
              {benefits.slice(0, 3).map((benefit, index) => (
                <div key={index} className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/20">
                  <CheckCircle2 className="w-6 h-6 text-green-400 mb-2 mx-auto" />
                  <p className="text-sm font-medium">{benefit}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
                Warum ein professioneller Firmenumzug?
              </h2>
              <p className="text-xl text-slate-600 leading-relaxed">
                Ein Firmenumzug ist komplexer als ein Privatumzug. Neben Möbeln müssen IT-Systeme, sensible Dokumente und oft teure Geräte transportiert werden. Ausfallzeiten kosten Geld. Mit einem professionellen Partner minimieren Sie Risiken, sparen Zeit und können sich auf Ihr Kerngeschäft konzentrieren.
              </p>
            </div>

            <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-2xl p-8 border-2 border-blue-200">
              <h3 className="text-2xl font-bold text-slate-900 mb-6 text-center">
                Alle Vorteile auf einen Blick:
              </h3>
              <div className="grid md:grid-cols-2 gap-4">
                {benefits.map((benefit, index) => (
                  <div key={index} className="flex items-center space-x-2">
                    <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0" />
                    <span className="text-slate-700">{benefit}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-slate-50">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
                Unsere Firmenumzug-Services
              </h2>
              <p className="text-xl text-slate-600">
                Von kleinen Startups bis zu grossen Unternehmen
              </p>
              <p className="text-lg text-slate-600 mt-4">
                Wir organisieren <strong>Firmenumzug Schweiz Deutschland</strong> aus allen Regionen: <Link to="/umzug-zuerich-deutschland" className="text-slate-900 font-semibold hover:underline">Umzug Zürich Deutschland</Link>, <Link to="/umzug-basel-deutschland" className="text-slate-900 font-semibold hover:underline">Umzug Basel Deutschland</Link>, <Link to="/umzug-bern-deutschland" className="text-slate-900 font-semibold hover:underline">Umzug Bern Deutschland</Link>. Neben Firmenumzügen bieten wir auch <Link to="/komplettumzug" className="text-slate-900 font-semibold hover:underline">Privatumzug Schweiz Deutschland</Link> und professionelle <Link to="/zollabwicklung" className="text-slate-900 font-semibold hover:underline">Zollabwicklung</Link>. Mehr zu <Link to="/preise" className="text-slate-900 font-semibold hover:underline">Umzug Schweiz Deutschland Kosten</Link>.
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-8">
              {services.map((service, index) => {
                const Icon = service.icon;
                return (
                  <div key={index} className="bg-white rounded-2xl p-8 border-2 border-slate-100 hover:border-slate-300 transition-all duration-300 hover:shadow-lg">
                    <div className="bg-slate-800 w-14 h-14 rounded-xl flex items-center justify-center mb-6">
                      <Icon className="w-7 h-7 text-white" />
                    </div>
                    <h3 className="text-2xl font-bold text-slate-900 mb-3">{service.title}</h3>
                    <p className="text-slate-600 mb-6 leading-relaxed">{service.description}</p>
                    <div className="border-t border-slate-200 pt-4">
                      <h4 className="font-semibold text-slate-900 mb-3">Wir transportieren:</h4>
                      <ul className="space-y-2">
                        {service.features.map((feature, idx) => (
                          <li key={idx} className="flex items-start space-x-2">
                            <CheckCircle2 className="w-4 h-4 text-green-600 flex-shrink-0 mt-1" />
                            <span className="text-sm text-slate-600">{feature}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
                Preise Firmenumzüge
              </h2>
              <p className="text-xl text-slate-600">
                Transparente Preise nach Unternehmensgrösse
              </p>
            </div>

            <div className="grid md:grid-cols-3 gap-6">
              {companySizes.map((company, index) => (
                <div
                  key={index}
                  className={`rounded-2xl p-8 border-2 transition-all duration-300 ${
                    company.popular
                      ? 'bg-slate-900 border-slate-900 text-white scale-105'
                      : 'bg-slate-50 border-slate-200 hover:border-slate-800'
                  }`}
                >
                  {company.popular && (
                    <div className="bg-green-500 text-white text-xs font-bold px-3 py-1 rounded-full inline-block mb-4">
                      BELIEBTESTE GRÖSSE
                    </div>
                  )}
                  <h3 className={`text-2xl font-bold mb-2 ${company.popular ? 'text-white' : 'text-slate-900'}`}>
                    {company.size}
                  </h3>
                  <p className={`text-sm mb-2 ${company.popular ? 'text-slate-300' : 'text-slate-600'}`}>
                    {company.employees}
                  </p>
                  <p className={`text-xs mb-4 ${company.popular ? 'text-slate-400' : 'text-slate-500'}`}>
                    {company.description}
                  </p>
                  <div className={`text-3xl font-bold mb-6 ${company.popular ? 'text-white' : 'text-slate-900'}`}>
                    {company.price}
                  </div>
                  <div className={`border-t mb-6 ${company.popular ? 'border-slate-700' : 'border-slate-300'}`} />
                  <ul className="space-y-3">
                    {company.includes.map((item, idx) => (
                      <li key={idx} className="flex items-start space-x-2">
                        <CheckCircle2
                          className={`w-5 h-5 flex-shrink-0 mt-0.5 ${
                            company.popular ? 'text-green-400' : 'text-green-600'
                          }`}
                        />
                        <span className={`text-sm ${company.popular ? 'text-slate-200' : 'text-slate-700'}`}>
                          {item}
                        </span>
                      </li>
                    ))}
                  </ul>
                  <button
                    onClick={scrollToContact}
                    className={`w-full mt-8 px-6 py-3 rounded-lg font-semibold transition-all duration-300 ${
                      company.popular
                        ? 'bg-white text-slate-900 hover:bg-slate-100'
                        : 'bg-slate-900 text-white hover:bg-slate-800'
                    }`}
                  >
                    Offerte anfordern
                  </button>
                </div>
              ))}
            </div>

            <div className="mt-8 text-center">
              <p className="text-slate-600">
                * Preise sind Richtwerte. Die finalen Kosten hängen von Distanz, Inventar und Zusatzleistungen ab.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-slate-50">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
                Spezialleistungen für Firmen
              </h2>
              <p className="text-xl text-slate-600">
                Massgeschneiderte Lösungen für Ihr Unternehmen
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-8">
              {specialServices.map((service, index) => {
                const Icon = service.icon;
                return (
                  <div key={index} className="bg-white rounded-2xl p-8 border-2 border-slate-100">
                    <div className="bg-slate-100 w-14 h-14 rounded-xl flex items-center justify-center mb-6">
                      <Icon className="w-7 h-7 text-slate-800" />
                    </div>
                    <h3 className="text-2xl font-bold text-slate-900 mb-3">{service.title}</h3>
                    <p className="text-slate-600 leading-relaxed">{service.description}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
                Warum Firmenumzüge bei uns?
              </h2>
              <p className="text-xl text-slate-600">
                Ihr verlässlicher Partner für Büroumzüge
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-8">
              {whyChooseUs.map((item, index) => {
                const Icon = item.icon;
                return (
                  <div key={index} className="bg-slate-50 rounded-2xl p-8 border-2 border-slate-100 hover:border-slate-300 transition-all duration-300 hover:shadow-lg">
                    <div className="bg-slate-800 w-14 h-14 rounded-xl flex items-center justify-center mb-6">
                      <Icon className="w-7 h-7 text-white" />
                    </div>
                    <h3 className="text-2xl font-bold text-slate-900 mb-3">{item.title}</h3>
                    <p className="text-slate-600 leading-relaxed">{item.description}</p>
                  </div>
                );
              })}
            </div>

            <div className="mt-12 bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl p-8 border-2 border-green-200">
              <h3 className="text-2xl font-bold text-slate-900 mb-6 text-center">
                Weitere Vorteile
              </h3>
              <div className="grid md:grid-cols-3 gap-6">
                {advantages.map((advantage, index) => (
                  <div key={index} className="text-center">
                    <CheckCircle2 className="w-8 h-8 text-green-600 mx-auto mb-3" />
                    <h4 className="font-bold text-slate-900 mb-2">{advantage.title}</h4>
                    <p className="text-sm text-slate-600">{advantage.description}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-slate-50">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
                So läuft Ihr Firmenumzug ab
              </h2>
              <p className="text-xl text-slate-600">
                5 Schritte zum erfolgreichen Umzug
              </p>
            </div>

            <div className="grid md:grid-cols-5 gap-6">
              {processSteps.map((step, index) => (
                <div key={index} className="bg-white rounded-2xl p-6 border-2 border-slate-100">
                  <div className="bg-slate-900 text-white w-12 h-12 rounded-xl flex items-center justify-center font-bold text-xl mb-4">
                    {step.step}
                  </div>
                  <h3 className="text-lg font-bold text-slate-900 mb-3">{step.title}</h3>
                  <p className="text-sm text-slate-600 leading-relaxed">{step.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
                Checkliste Firmenumzug
              </h2>
              <p className="text-xl text-slate-600">
                Damit Sie nichts vergessen
              </p>
            </div>

            <div className="grid md:grid-cols-3 gap-6">
              {checklist.map((section, index) => (
                <div key={index} className="bg-slate-50 rounded-2xl p-6 border-2 border-slate-100">
                  <div className="bg-slate-800 w-12 h-12 rounded-xl flex items-center justify-center mb-4">
                    <Calendar className="w-6 h-6 text-white" />
                  </div>
                  <h3 className="text-xl font-bold text-slate-900 mb-4">{section.phase}</h3>
                  <ul className="space-y-2">
                    {section.items.map((item, idx) => (
                      <li key={idx} className="flex items-start space-x-2">
                        <CheckCircle2 className="w-4 h-4 text-green-600 flex-shrink-0 mt-1" />
                        <span className="text-sm text-slate-600">{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-slate-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
                Das sagen unsere Firmenkunden
              </h2>
              <p className="text-xl text-slate-600">
                Vertrauen Sie auf unsere Erfahrung
              </p>
            </div>

            <div className="grid md:grid-cols-3 gap-6">
              {testimonials.map((testimonial, index) => (
                <div key={index} className="bg-white rounded-2xl p-6 border-2 border-slate-100">
                  <div className="flex items-center mb-4">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
                    ))}
                  </div>
                  <p className="text-slate-700 mb-4 leading-relaxed">"{testimonial.text}"</p>
                  <div className="border-t border-slate-200 pt-4">
                    <div className="font-semibold text-slate-900">{testimonial.name}</div>
                    <div className="text-sm text-slate-500">{testimonial.location}</div>
                    <div className="text-xs text-slate-400 mt-1">{testimonial.employees}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
                Häufig gestellte Fragen
              </h2>
              <p className="text-xl text-slate-600">
                Alles über Firmenumzüge von der Schweiz nach Deutschland
              </p>
            </div>

            <div className="space-y-4">
              {faqs.map((faq, index) => (
                <div
                  key={index}
                  className="bg-slate-50 rounded-xl border-2 border-slate-100 overflow-hidden transition-all duration-300 hover:border-slate-300"
                >
                  <button
                    onClick={() => toggleFaq(index)}
                    className="w-full px-6 py-5 flex items-center justify-between text-left"
                  >
                    <span className="font-semibold text-slate-900 pr-4">{faq.question}</span>
                    <ChevronDown
                      className={`w-5 h-5 text-slate-600 transition-transform duration-300 flex-shrink-0 ${
                        openFaq === index ? 'transform rotate-180' : ''
                      }`}
                    />
                  </button>
                  {openFaq === index && (
                    <div className="px-6 pb-5">
                      <p className="text-slate-600 leading-relaxed" dangerouslySetInnerHTML={{ __html: faq.answer }} />
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <Contact />
    </div>
  );
}
